import { useCallback } from 'react';
import useGet from '../../lib/api/useGet';
import { getSchema } from './api';
import { SchemaProvider } from './types';

export type UseSchemaResult = {
  loading: boolean;
  error: undefined | Error;
  data: SchemaProvider | null;
  refetch: () => void;
};

const useSchema = (id: number | string): UseSchemaResult => {
  const get = useCallback((): Promise<SchemaProvider> => getSchema(id), [id]);
  return useGet(get);
};

export default useSchema;
